/**
 * @file Re-exports the MyProfile component.
 */

import MyProfile from "./MyProfile";

export default MyProfile;
